import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// عند كل تغيير للمسار، أعِد تمرير الصفحة إلى الأعلى — منعاً لإرث نقطة التمرير من الصفحة السابقة.
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);
  return null;
};
